(function () {
  if (window.__mailupSignup) return;
  window.__mailupSignup = true;

  var ENDPOINT = 'https://g5h6g.mailupclient.com/frontend/subscribe.aspx';
  var KEY = 'mailup_subscribed_28';

  function isDone() {
    try { return window.localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function remember() {
    try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function init(root) {
    if (root.__mu) return;
    root.__mu = true;
    var form = root.querySelector('[data-mailup-form]');
    var ok = root.querySelector('[data-success]');
    var err = root.querySelector('[data-error]');
    var btn = root.querySelector('[data-submit]');
    var d = root.dataset;
    if (!form) return;

    var inner = root.closest('.popup__inner');
    var popupText = inner ? inner.querySelector('.popup__text') : null;

    function fail(msg) {
      err.textContent = msg || '';
      err.hidden = !msg;
    }
    function success() {
      remember();
      form.hidden = true;
      if (popupText) popupText.hidden = true;
      ok.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      fail('');
      var email = form.elements.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { fail(d.msgBadEmail); return; }
      if (!form.elements.consent.checked) { fail(d.msgBadConsent); return; }
      if (form.elements.website.value) { success(); return; }

      var picked = form.querySelector('input[type="radio"]:checked');
      var body = new URLSearchParams();
      body.append('list', d.list);
      body.append('apgroup', d.apgroup);
      body.append('email', email);
      if (picked) body.append('group', picked.value);
      body.append('Submit', 'Invia');

      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = d.msgSending;
      fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', credentials: 'omit', body: body })
        .then(success, function () { fail(d.msgError); })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mailup-signup]').forEach(init);
    if (isDone()) {
      document.querySelectorAll('.popup--large').forEach(function (el) { el.remove(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
